export const FLOAT_EPSILON = Math.pow(2, -52);

export const MIN_VISIBLE = 32;
export const CUT_WIDTH = 4;



// WEBPACK FOOTER //
// ./src/constants.ts